import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/t/departments')({
  staticData: { breadcrumb: 'Departments', breadcrumbKey: 'K_BREADCRUMB_DEPARTMENTS' },
  component: DepartmentsLayout,
});

function DepartmentsLayout() {
  return <Outlet />;
}
